import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth.jsx";
import { LayoutDashboard, MessageSquare, Map, Bookmark, Calculator, LogOut, UserCircle, FolderOpen, Brain } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  if (loc.pathname === "/start") return null;
  if (loc.pathname === "/" || loc.pathname === "/auth") {
    return (
      <header className="sticky top-0 z-50 backdrop-blur-md bg-black/70 border-b border-[#2A2E39]">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="font-display font-black text-lg tracking-tight" data-testid="brand-link">
            <span className="text-white">I HATE </span><span className="text-[#FD0F10]">MY JOB.</span><span className="text-white">APP</span>
          </Link>
          {user ? (
            <Link to="/dashboard" className="text-sm font-mono-ui uppercase tracking-wider text-white hover:text-[#FD0F10]" data-testid="nav-dashboard">
              Dashboard →
            </Link>
          ) : (
            <Link to="/auth" className="text-sm font-mono-ui uppercase tracking-wider text-white hover:text-[#FD0F10]" data-testid="nav-signin">
              Sign in
            </Link>
          )}
        </div>
      </header>
    );
  }

  if (!user) return null;

  const items = [
    { to: "/dashboard", label: "Ideas", icon: LayoutDashboard, testid: "nav-dashboard" },
    { to: "/coach", label: "Coach", icon: MessageSquare, testid: "nav-coach" },
    { to: "/roadmap", label: "Path", icon: Map, testid: "nav-roadmap" },
    { to: "/exit", label: "Exit#", icon: Calculator, testid: "nav-exit" },
    { to: "/saved", label: "Saved", icon: Bookmark, testid: "nav-saved" },
    { to: "/work", label: "My Work", icon: FolderOpen, testid: "nav-my-work" },
    { to: "/mindset", label: "Mindset", icon: Brain, testid: "nav-mindset" },
  ];

  return (
    <>
      <header className="sticky top-0 z-50 backdrop-blur-md bg-black/80 border-b border-[#2A2E39]">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/dashboard" className="font-display font-black text-lg tracking-tight" data-testid="brand-link">
            <span className="text-white">I HATE </span><span className="text-[#FD0F10]">MY JOB.</span><span className="text-white">APP</span>
          </Link>
          <div className="flex items-center gap-3">
            {user.is_premium && <span className="text-[10px] font-mono-ui uppercase tracking-wider bg-[#FD0F10] text-white px-2 py-1 rounded" data-testid="pro-badge">PRO</span>}
            {!user.is_premium && (
              <Link to="/pro" className="text-xs font-mono-ui uppercase tracking-wider text-[#FD0F10] border border-[#FD0F10] px-3 py-1.5 rounded hover:bg-[#FD0F10] hover:text-white transition" data-testid="nav-upgrade">
                Upgrade
              </Link>
            )}
            <Link to="/account" className="text-gray-400 hover:text-white" data-testid="nav-account" title="Your account"><UserCircle size={20} /></Link>
            <button onClick={() => { logout(); nav("/"); }} className="text-gray-400 hover:text-white" data-testid="nav-logout" title="Sign out">
              <LogOut size={18} />
            </button>
          </div>
        </div>
      </header>
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-[#0B0C0E]/95 backdrop-blur-md border-t border-[#2A2E39] mob-nav-shadow safe-bottom">
        <div className="max-w-6xl mx-auto grid grid-cols-7">
          {items.map(({ to, label, icon: Icon, testid }) => {
            const active = loc.pathname.startsWith(to);
            return (
              <Link key={to} to={to} className={`flex flex-col items-center py-2.5 min-h-[52px] active:opacity-70 text-[9px] sm:text-[10px] font-mono-ui uppercase tracking-wide sm:tracking-wider whitespace-nowrap ${active ? "text-[#FD0F10]" : "text-gray-400"}`} data-testid={testid}>
                <Icon size={20} />
                <span className="mt-1">{label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}
